import { ErrorHandler } from '@angular/core';

class CustomError extends Error {
    constructor (m: string) {
        super (m);
        // Set the prototype explicitly.
        Object.setPrototypeOf (this, CustomError.prototype);
    }
}


export class ReportToInstanaErrorHandler implements ErrorHandler {

    handleError(error) {
        if (typeof ineum !== 'undefined') {
            if (window['celineTargetCE']) {
                let customError = new CustomError(`@${window['celineTargetCE']}: ${error}`);
                ineum('reportError', customError);
            }
        }
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/services/reportToInstana.errorHandler.ts